import { useState } from 'react';
import type { PortfolioDetailedReturns } from '../../hooks/usePortfolioDetailedReturns';

import { EmptyState } from './EmptyState';
import { PopulatedState } from './PopulatedState';

import Observer from '@researchgate/react-intersection-observer';
import type { PortfolioType } from '../../../HoldingsTable/hooks';

type Holding = PortfolioDetailedReturns['holdings'][number];

type Props = {
  currencyISO: string;
  holding: Holding;
  portfolioType: PortfolioType;
};

// In principle, these heights should remain relatively constant, unless the layout changes
const HOLDING_OVERVIEW_HEIGHT = 278;
const TRANSACTION_HEADER_HEIGHT = 126;
const TRANSACTION_ROW_HEIGHT = 46;

const getSectionHeight = (transactionsCount: number) =>
  HOLDING_OVERVIEW_HEIGHT +
  TRANSACTION_HEADER_HEIGHT +
  TRANSACTION_ROW_HEIGHT * transactionsCount;

export const Transactions = ({
  currencyISO,
  holding,
  portfolioType,
}: Props) => {
  const [visible, setVisible] = useState(!window?.TEST_RUNNER ? true : false);

  if (visible && holding.detailedTransactions.length === 0)
    return (
      <EmptyState
        currencyISO={currencyISO}
        holding={holding}
        portfolioType={portfolioType}
      />
    );

  if (visible) {
    return (
      <PopulatedState
        currencyISO={currencyISO}
        holding={holding}
        portfolioType={portfolioType}
      />
    );
  }

  return (
    <Observer
      onChange={({ isIntersecting }) => {
        if (isIntersecting && !visible) {
          setVisible(true);
        }
      }}
    >
      <tbody>
        <tr
          style={{
            height: getSectionHeight(holding.detailedTransactions.length),
          }}
          className="bg-attention"
        ></tr>
      </tbody>
    </Observer>
  );
};
